import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { isCarSalesOrder, isCarRentOrder, isItemSalesOrder } from 'helpers/order';

import Breadcrumb from 'components/layout/Breadcrumb';

class CreateDelivery extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { intl, appIntl, orderData } = this.props;
    const messages = intl.messages;

    return (
      <div class="padding-25 sm-padding-10">
        <Breadcrumb
          crumbs={[
            { link: appIntl.urlPrefix + 'account', name: 'Dashboard' },
            { link: appIntl.urlPrefix + 'account/orders', name: messages.orders },
            { link: appIntl.urlPrefix + 'account/orders/' + orderData.id, name: orderData.id },
            { link: null, name: 'Create delivery' },
          ]}
          className="p-t-0"
        />
      </div>
    );
  }
}
CreateDelivery.defaultProps = {};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(CreateDelivery)));
